
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const ImageMapComponent = () => {
    useEffect(() => {
      console.log('in FloorSelectionbannermobile');
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
                window.ImageMapPro.init('#image-map-pro', {
                  "id": "9aefa7b3-4cb3-4c92-a641-184d9910c8c6",
                  "general": {
                    "name": "Mobile"
                  },
                  "artboards": [
                    {
                      "background_type": "image",
                      "image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/Mobile.jpg",
                      "width": 430,
                      "height": 944,
                      "use_image_size": true,
                      "children": [
                        {
                          "id": "9e7d6ed4-1e47-48ae-80e1-d7f599bcbd17",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.251826973848566,
                          "y": 14.917348679208198,
                          "width": 12.354651162790695,
                          "height": 2.3834770419642997,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "38,39<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Sky Villa",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/38",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "f68e975e-1f3c-4b63-9e66-4d7339f8038b"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/38';"
                          // },
                          "x_image_background": 9.251826973848566,
                          "y_image_background": 14.917348679208198
                        },
                        {
                          "id": "f6c5613d-f70b-4e69-8a63-1f2e91bee201",
                          "title": "Rect",
                          "type": "rect",
                          "x": 79.92043073787246,
                          "y": 14.400928653449267,
                          "width": 12.936046511627907,
                          "height": 2.3702355028422737,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "36,37<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/36",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "7186eafe-66b6-4f3e-8be1-d459229a0482"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/36';"
                          // },
                          "x_image_background": 79.92043073787246,
                          "y_image_background": 14.400928653449267
                        },
                        {
                          "id": "eda4d07b-5cb0-4786-9fbc-7441615812d8",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.339037163313044,
                          "y": 21.8029474062618,
                          "width": 12.267441860465116,
                          "height": 2.3702355028422772,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "34,35<br><div>_________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Sky Villa",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/34",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ad927b",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "beb541e4-a404-4fcc-9ceb-0605a3dffa5d"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/34';"
                          // },
                          "x_image_background": 9.339037163313044,
                          "y_image_background": 21.8029474062618
                        },
                        {
                          "id": "669bb549-f299-4d89-bd08-5f39e8b2a872",
                          "title": "Rect",
                          "type": "rect",
                          "x": 79.7460085846657,
                          "y": 22.014813648613,
                          "width": 12.529069767441854,
                          "height": 2.423201659330374,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "32,33<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/32",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "dba7d1e1-4891-4b1d-b87d-8050f3215b66"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/32';"
                          // },
                          "x_image_background": 79.97856672420059,
                          "y_image_background": 22.014813648613
                        },
                        {
                          "id": "fb2e4e0a-5cf2-4c37-8079-3cc8410a9268",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.193686551825945,
                          "y": 28.675307826991016,
                          "width": 12.5,
                          "height": 2.3967185810863256,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "30,31<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "07 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Sky Villa",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "02 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/30",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#aa907a",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "83bf7a1c-ddaa-40aa-96d9-730db9311f45"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/30';"
                          // },
                          "x_image_background": 9.193686551825945,
                          "y_image_background": 28.675307826991016
                        },
                        {
                          "id": "d5b30e90-d516-4976-abe5-598fd90b1a6f",
                          "title": "Rect",
                          "type": "rect",
                          "x": 79.94949695675872,
                          "y": 29.6551833384196,
                          "width": 12.674418604651166,
                          "height": 2.5423755114285918,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "28,29<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/28",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "8318b1df-cb2b-4766-b8c0-2b3c6f3305fb"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/28';"
                          // },
                          "x_image_background": 79.94949695675872,
                          "y_image_background": 29.6551833384196
                        },
                        {
                          "id": "4998f489-9b45-4c0b-8ae9-7d311caed251",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.280896741290425,
                          "y": 35.56090978684225,
                          "width": 12.354651162790697,
                          "height": 2.4099601202083534,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "26,27<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/26",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "76edd55d-d002-4df9-9c0c-15586ef24073"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/26';"
                          // },
                          "x_image_background": 9.280896741290425,
                          "y_image_background": 35.56090978684225
                        },
                        {
                          "id": "e2d1a3b7-62d3-4eec-ab95-bf561bde8096",
                          "title": "Rect",
                          "type": "rect",
                          "x": 79.891357421875,
                          "y": 36.9380266227351,
                          "width": 12.732558139534888,
                          "height": 2.4099601202083463,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "24,25<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/24",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "3bfebb14-e3df-48bd-bd10-f95d6780797b"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/24';"
                          // },
                          "x_image_background": 79.891357421875,
                          "y_image_background": 36.9380266227351
                        },
                        {
                          "id": "a143d6d0-4fc4-4af9-a50a-36d5d78e9a69",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.135548791220021,
                          "y": 42.43326535837502,
                          "width": 12.58720930232558,
                          "height": 2.4496847375744224,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "22,23<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/22",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "e1faf7f8-c336-4520-a213-0b227dca2325"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/22';"
                          // },
                          "x_image_background": 9.135548791220021,
                          "y_image_background": 42.43326535837502
                        },
                        {
                          "id": "df030677-4dc8-4bf4-bd8a-fac893d7c1f3",
                          "title": "Rect",
                          "type": "rect",
                          "x": 79.8913609704306,
                          "y": 47.02808266651494,
                          "width": 12.674418604651166,
                          "height": 2.383477041964298,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "19,20<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/19",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "cda49d1f-a530-4e03-847a-5985e21b2e14"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/19';"
                          // },
                          "x_image_background": 79.8913609704306,
                          "y_image_background": 47.02808266651494
                        },
                        {
                          "id": "5840223a-46bf-4a35-ae06-8f91ad3a3b99",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.164617671522983,
                          "y": 51.64937658730364,
                          "width": 12.441860465116278,
                          "height": 2.3967185810863185,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "17,18<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/17",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a6457a4e-83f0-43b0-82b8-46f2d110eabf"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/17';"
                          // },
                          "x_image_background": 9.164617671522983,
                          "y_image_background": 51.64937658730364
                        },
                        {
                          "id": "3d036ece-c429-48a6-828d-fc1d79f78f09",
                          "title": "Rect",
                          "type": "rect",
                          "x": 79.94950050531432,
                          "y": 54.50955227045844,
                          "width": 12.645348837209298,
                          "height": 2.42320165933036,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "15,16<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/15",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "1721c2f4-4b82-42e2-ba2e-1dd4d8ae4245"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/15';"
                          // },
                          "x_image_background": 79.94950050531432,
                          "y_image_background": 54.50955227045844
                        },
                        {
                          "id": "d277d70d-a7d1-48e8-9dea-13c9931c6551",
                          "title": "Rect",
                          "type": "rect",
                          "x": 9.251826530279116,
                          "y": 58.41580631145548,
                          "width": 12.383720930232558,
                          "height": 2.4364431984523875,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "13,14<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/13",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ad927b",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "70c37322-b72e-4b89-862e-bc8d1deed0ff"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/13';"
                          // },
                          "x_image_background": 9.251826530279116,
                          "y_image_background": 58.41580631145548
                        },
                        {
                          "id": "5f824567-4632-4e4d-8b2f-a416a085cd4c",
                          "title": "Rect",
                          "type": "rect",
                          "x": 78.81577957508176,
                          "y": 61.514326466009074,
                          "width": 5.116279069767444,
                          "height": 2.383477041964298,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "12<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/12",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "fbac0deb-0f73-419d-b51a-1d8990d1b7dc"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/12';"
                          // },
                          "x_image_background": 78.81577957508176,
                          "y_image_background": 61.514326466009074
                        },
                        {
                          "id": "3006a364-4200-492d-b477-e6d68f931884",
                          "title": "Rect",
                          "type": "rect",
                          "x": 10.385547016942223,
                          "y": 62.53392497840491,
                          "width": 5.145348837209305,
                          "height": 2.3305108854762153,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "11<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/11",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c77b1e14-88ab-47fb-9ad1-e90bbd313aa0"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/11';"
                          // },
                          "x_image_background": 10.385547016942223,
                          "y_image_background": 62.53392497840491
                        },
                        {
                          "id": "f2e19784-8ad8-438b-8800-c3c24833461e",
                          "title": "Rect",
                          "type": "rect",
                          "x": 85.73438422624456,
                          "y": 65.20871588105373,
                          "width": 5.145348837209298,
                          "height": 2.3702355028422772,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "10<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/10",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "4598b4a3-31c1-456a-85d8-ce470260ea54"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/10';"
                          // },
                          "x_image_background": 85.73438422624456,
                          "y_image_background": 65.20871588105373
                        },
                        {
                          "id": "50b40cdf-14ef-4116-abc3-2db5b532377e",
                          "title": "Rect",
                          "type": "rect",
                          "x": 17.391360970430597,
                          "y": 66.08265746310731,
                          "width": 5.087209302325579,
                          "height": 2.3305108854762153,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "9<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/9",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "b8e98b6d-8871-4c7a-8afe-bf5424e0f98b"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/9';"
                          // },
                          "x_image_background": 17.391360970430597,
                          "y_image_background": 66.08265746310731
                        },
                        {
                          "id": "052b1751-0c63-4470-afde-12317788da21",
                          "title": "Rect",
                          "type": "rect",
                          "x": 78.84484934252362,
                          "y": 69.27386839151507,
                          "width": 4.970930232558146,
                          "height": 2.330510885476201,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "8<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/8",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "388eb15a-5547-42b8-a7fc-aba40d64000d"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/8';"
                          // },
                          "x_image_background": 78.84484934252362,
                          "y_image_background": 69.27386839151507
                        },
                        {
                          "id": "58fbf430-ffdd-4bf0-bd8c-edb11749cf20",
                          "title": "Rect",
                          "type": "rect",
                          "x": 10.443686551825945,
                          "y": 69.6843561042978,
                          "width": 5.029069767441861,
                          "height": 2.343752424598236,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "7<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Two Bedroom Penthouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "03 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "04 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/7",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "6b70e95c-94e6-4539-962e-fba9d5c6a51f"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/7';"
                          // },
                          "x_image_background": 10.443686551825945,
                          "y_image_background": 69.6843561042978
                        },
                        {
                          "id": "61ced36e-49e2-4eb6-b0f7-3315a3e085eb",
                          "title": "Rect",
                          "type": "rect",
                          "x": 85.8506668445676,
                          "y": 73.10066673218469,
                          "width": 5.02906976744184,
                          "height": 2.343752424598236,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "6<div><div>__________________</div></div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/6",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "d642209b-50d8-48bc-99b1-607f13599457"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/6';"
                          // },
                          "x_image_background": 85.8506668445676,
                          "y_image_background": 73.10066673218469
                        },
                        {
                          "id": "808bd192-9140-4c59-99c4-a542a862ae1d",
                          "title": "Rect",
                          "type": "rect",
                          "x": 17.333222322685774,
                          "y": 73.2860547454883,
                          "width": 5.145348837209301,
                          "height": 2.3569939637202566,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "5<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/5",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ad927b",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "403881a5-e803-4209-8d4c-63e2d8dbf3c5"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/5';"
                          // },
                          "x_image_background": 17.333222322685774,
                          "y_image_background": 73.2860547454883
                        },
                        {
                          "id": "02d4fdb6-8135-4407-a43f-6f7bfebd24d1",
                          "title": "Rect",
                          "type": "rect",
                          "x": 78.81577602652617,
                          "y": 76.7685795345806,
                          "width": 5.11627906976743,
                          "height": 2.383477041964298,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "4<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/4",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 400,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "eac6a168-d5b2-42bb-b684-267066864825"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/4';"
                          // },
                          "x_image_background": 78.81577602652617,
                          "y_image_background": 76.7685795345806
                        },
                        {
                          "id": "a2eecf88-b787-4f3d-9283-bea876eed115",
                          "title": "Rect",
                          "type": "rect",
                          "x": 10.443686551825945,
                          "y": 76.91422999932757,
                          "width": 5.029069767441861,
                          "height": 2.330510885476201,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "3<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/3",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 500,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "1c494157-de94-4a28-970b-fa5a8fa60165"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/3';"
                          // },
                          "x_image_background": 10.443686551825945,
                          "y_image_background": 76.91422999932757
                        },
                        {
                          "id": "18e5a559-5272-4d75-a780-6b165e300cd1",
                          "title": "Rect",
                          "type": "rect",
                          "x": 85.79252730968386,
                          "y": 80.37027171017581,
                          "width": 5.058139534883722,
                          "height": 2.383477041964298,
                          "mouseover_style": {
                            "background_color": "#0e2b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "left"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "2<br><div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "13 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/2",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 500,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "13727571-7f2b-4846-9ddf-1a35e5c91112"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/2';"
                          // },
                          "x_image_background": 85.79252730968386,
                          "y_image_background": 80.37027171017581
                        },
                        {
                          "id": "1b672bf5-27d2-4478-b3a0-74cc23c75dee",
                          "title": "Rect",
                          "type": "rect",
                          "x": 17.30442432072698,
                          "y": 80.45066375027632,
                          "width": 5.2891060897599615,
                          "height": 2.409227996830225,
                          "default_style": {
                            "background_color": "#0e2b33"
                          },
                          "mouseover_style": {
                            "background_color": "#032b33"
                          },
                          "tooltip_style": {
                            "background_color": "#0e2b33",
                            "position": "right"
                          },
                          "tooltip_content": [
                            {
                              "type": "Heading",
                              "text": "Floor",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "909c2ec8-5790-4a8b-a4a0-75126515a759"
                            },
                            {
                              "type": "Heading",
                              "text": "1<div>__________________</div>",
                              "heading": "h3",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 20.8,
                                "lineHeight": "normal",
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "5",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "ab47f3e7-07d7-4ad7-bf46-ef799988ddf3"
                            },
                            {
                              "type": "Paragraph",
                              "text": "One Bedroom Townhouse",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "a2773e38-307d-4c49-9db1-a0066ca9ff8c"
                            },
                            {
                              "type": "Paragraph",
                              "text": "01 Unit",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "c02056f2-4c47-4041-8faa-6f69d07b09cd"
                            },
                            {
                              "type": "Paragraph",
                              "text": "Designer Suite",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "italiana",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ffffff",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "10",
                                  "bottom": "5",
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "073d9d96-b211-4540-9b50-36f671207877"
                            },
                            {
                              "type": "Paragraph",
                              "text": "09 Units",
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "fontFamily": "barlow",
                                "fontSize": 19,
                                "lineHeight": 22,
                                "color": "#ad937b",
                                "textAlign": "left"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": "auto",
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": "0",
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "0056d581-4cb5-483c-bac6-443437920558"
                            },
                            {
                              "type": "Button",
                              "text": "Select Unit",
                              "url": "https://autographiseries.greengroup.ae/unit-selection/1",
                              "script": "",
                              "newTab": false,
                              "other": {
                                "id": "",
                                "classes": "",
                                "css": ""
                              },
                              "style": {
                                "backgroundColor": "#ae937c",
                                "borderRadius": 100,
                                "fontFamily": "barlow",
                                "fontWeight": 500,
                                "fontSize": 18,
                                "lineHeight": 44,
                                "color": "#0e2b33",
                                "display": "block"
                              },
                              "boxModel": {
                                "width": "auto",
                                "height": 44,
                                "margin": {
                                  "top": 0,
                                  "bottom": 0,
                                  "left": 0,
                                  "right": 0
                                },
                                "padding": {
                                  "top": 10,
                                  "bottom": 10,
                                  "left": 10,
                                  "right": 10
                                }
                              },
                              "id": "09777b47-610d-47c6-9216-50039e9e3a43"
                            }
                          ],
                          // "actions": {
                          //   "click": "run-script",
                          //   "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-selection/1';"
                          // },
                          "x_image_background": 17.30442432072698,
                          "y_image_background": 80.45066375027632
                        }
                      ]
                    }
                  ],
                  "version": "6.0.20"});
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        <div id="image-map-pro"></div>
    );
};

const FloorSelectionbanner = () => {
    return (
        <div className='floorselection-main-div'>
            <div className='container'>
                {/* main-building-img */}
                <div className='main-building-img'>
                <Helmet>
                    <script src="/js/image-map-pro.min.js"></script>
                </Helmet>
                <ImageMapComponent />
                </div>
            </div>

        </div>
    );
};

export default FloorSelectionbanner;
